import {Loader} from '@googlemaps/js-api-loader';

import getConfig from '~/load_config';

let _promise: Promise<typeof google>;

export function initGoogleMapsAPI(): void {
  if (!_promise) {
    _promise = new Loader({
      apiKey: getConfig().googleMapsApiKey,
      libraries: ['places'],
    }).load();
  }
}

export function getGoogleMapsAPI(): Promise<typeof google> {
  if (!_promise) {
    initGoogleMapsAPI();
  }

  return _promise;
}
